import { FormInputTypes } from '@components/_old/dynamicForm';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const getPolicyFiltersView = (
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord,
  layoutName: 'policy' | 'groupPolicy' | 'productionDistribution'
): IListingFilterWidgetSection[] => {
  const isPolicyLayout = layoutName === 'policy';
  const isGroupPolicyLayout = layoutName === 'groupPolicy';

  return [
    {
      title: 'Filters',
      inputs: {
        line: {
          name: 'line',
          title: 'Line',
          type: FormInputTypes.newmultiselect,
          value: filterValues.line || [],
          placeholder: 'Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line }
        },
        subline: {
          name: 'subline',
          title: 'Subline',
          type: FormInputTypes.newmultiselect,
          value: filterValues.subline || [],
          placeholder: 'Subline',
          triggerUpdate: true,
          selectOptions: { ...lovs.subline }
        },
        plan: {
          name: 'plan',
          title: 'Plan',
          type: FormInputTypes.newmultiselect,
          value: filterValues.plan || [],
          placeholder: 'Plan',
          triggerUpdate: true,
          selectOptions: { ...lovs.plan }
        },
        businessPartner: {
          name: 'businessPartner',
          title: 'Broker',
          type: FormInputTypes.newmultiselect,
          value: filterValues.businessPartner || [],
          placeholder: 'Broker',
          triggerUpdate: true,
          selectOptions: { ...lovs.businessPartner },
          hidden: !isPolicyLayout && !isGroupPolicyLayout
        },
        ownerID: {
          name: 'ownerID',
          title: 'Owner',
          type: FormInputTypes.newmultiselect,
          value: filterValues.ownerID || [],
          placeholder: 'Owner',
          triggerUpdate: true,
          selectOptions: { ...lovs.ownerID },
          hidden: !isPolicyLayout && !isGroupPolicyLayout
        },
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.newmultiselect,
          value: filterValues.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: { ...lovs.status },
          hidden: !isPolicyLayout && !isGroupPolicyLayout
        },
        issueDate: {
          name: 'issueDate',
          title: 'Issue Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.issueDate || [],
          placeholder: 'Issue Date',
          triggerUpdate: true,
          hidden: !isPolicyLayout && !isGroupPolicyLayout
        },
        effectiveDate: {
          name: 'effectiveDate',
          title:
            isPolicyLayout || isGroupPolicyLayout
              ? 'Effective Date'
              : 'Policy Effective Date',
          type: FormInputTypes.newdaterange,
          value: filterValues.effectiveDate || [],
          placeholder:
            isPolicyLayout || isGroupPolicyLayout
              ? 'Effective Date'
              : 'Policy Effective Date',
          triggerUpdate: true
        }
      }
    }
  ];
};
